import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { ICerere } from '../../../cereri.interface';
import { CereriService } from '../../../cereri.service';
import { AddProgramareService } from '../../../add-programare/add-programare.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-edit-programare-config',
    templateUrl: './edit-programare-config.component.html',
    styleUrls: ['./edit-programare-config.component.scss']
})
export class EditProgramareConfigComponent implements OnInit {
    helper = helper;
    isLoading = false;
    loadingNomenclatoare = false;

    cerereData: ICerere | null = null;

    // Liste nomenclatoare
    tipuriProblema: any[] = [];
    tipuriProgram: any[] = [];

    form: FormGroup = new FormGroup({
        id_problem_type: new FormControl(-1),
        id_program_type: new FormControl(-1),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { cerereData: ICerere },
        private dialogRef: MatDialogRef<EditProgramareConfigComponent>,
        private cereriService: CereriService,
        private addProgramareService: AddProgramareService,
        private notificationService: NotificationService,
    ) {
        this.cerereData = data.cerereData;
    }

    ngOnInit() {
        if (this.cerereData?.programare) {
            // Pre-selectăm valorile curente
            this.form.patchValue({
                id_problem_type: this.cerereData.id_cerere_type || -1,
                id_program_type: this.cerereData.programare.id_program_type || -1,
            });

            // Încarcă nomenclatoarele pe baza configurației existente
            this.loadNomenclatoare();
        }
    }

    loadNomenclatoare() {
        if (!this.cerereData?.programare) return;

        this.loadingNomenclatoare = true;
        const programare = this.cerereData.programare;

        // Încarcă tipurile de problemă pentru serviciul curent
        this.addProgramareService.getTipuriProblemaByServiciu(programare.id_serviciu)
            .subscribe({
                next: (res: any) => {
                    this.tipuriProblema = res?.data || [];
                },
                error: () => {
                    this.tipuriProblema = [];
                }
            });

        // Încarcă tipurile de program pentru configurația curentă
        this.addProgramareService.getTipuriProgramByConfig(
            programare.id_modul,
            programare.id_locatie,
            programare.id_serviciu
        ).pipe(finalize(() => this.loadingNomenclatoare = false))
            .subscribe({
                next: (res: any) => {
                    this.tipuriProgram = res?.data || [];
                },
                error: () => {
                    this.tipuriProgram = [];
                }
            });
    }

    closeDialog() {
        this.dialogRef.close({ success: false });
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Confirmați actualizarea configurației programării?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateConfig();
            }
        });
    }

    updateConfig() {
        this.isLoading = true;

        const payload: any = {};

        // Adaugă doar dacă s-a schimbat
        if (this.form.value.id_problem_type !== null && this.form.value.id_problem_type !== -1 &&
            this.form.value.id_problem_type !== this.cerereData?.id_cerere_type) {
            payload.id_problem_type = this.form.value.id_problem_type;
        }

        if (this.form.value.id_program_type !== null && this.form.value.id_program_type !== -1 &&
            this.form.value.id_program_type !== this.cerereData?.programare?.id_program_type) {
            payload.id_program_type = this.form.value.id_program_type;
        }

        // Verifică dacă există modificări
        if (Object.keys(payload).length === 0) {
            this.isLoading = false;
            Swal.fire({
                title: 'Info',
                text: 'Nu au fost modificări de salvat.',
                icon: 'info',
                confirmButtonText: helper.dialogConfig.buttonLabels.close,
            });
            return;
        }

        this.cereriService
            .updateProgramareConfig(this.cerereData!.id, payload)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: (res: any) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: res?.payload?.message || 'Configurația a fost actualizată cu succes.',
                        icon: 'success',
                        confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then(() => {
                        this.dialogRef.close({ success: true });
                    });
                },
                error: (err) => {
                    let msg = err?.error?.errors?.message?.[0] || helper.dialogConfig.generalMessages.error;
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        helper.dialogConfig.icons.error
                    );
                },
            });
    }
}
